import { apiFetch } from "../http";
export async function getOnboardingState(params) {
    const { baseUrl, token, signal } = params;
    return apiFetch(`/user/api/user/onboarding/`, {
        baseUrl,
        token,
        method: "GET",
        signal,
        redirectOnUnauthorized: false,
    });
}
export async function completeOnboardingTour(params) {
    const { baseUrl, token, tourId, status } = params;
    return apiFetch(`/user/api/user/onboarding/complete/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tour_id: tourId, status }),
        redirectOnUnauthorized: false,
    });
}
export async function resetOnboarding(params) {
    const { baseUrl, token, tourId } = params;
    return apiFetch(`/user/api/user/onboarding/reset/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tourId ? { tour_id: tourId } : {}),
        redirectOnUnauthorized: false,
    });
}
